(() => {
  const countryElement = document.querySelector("[data-current-country]");
  const shopsListContainer = document.querySelector(".online-shops__shops-list");

  if (!countryElement || !shopsListContainer) return;

  const currentCountry = (countryElement.dataset.currentCountry || "")
    .trim()
    .toLowerCase();

  if (!currentCountry) {
    shopsListContainer.classList.add("empty");
    return;
  }

  const baseUrl = (window.shopUrl || window.location.origin).replace(/\/$/, "");
  const pageUrls = [
    `${baseUrl}/pages/retailer-countries-part-1`,
    `${baseUrl}/pages/retailer-countries-part-2`,
  ];

  appendNewShopList();

  async function fetchDocument(url) {
    const response = await fetch(url, {
      method: "GET",
      credentials: "same-origin",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}: ${response.status}`);
    }

    const responseText = await response.text();
    return new DOMParser().parseFromString(responseText, "text/html");
  }

  function findCountryList(doc) {
    const countrySections = doc.querySelectorAll("[data-country]");

    for (const section of countrySections) {
      const sectionCountry = (section.getAttribute("data-country") || "")
        .trim()
        .toLowerCase();

      if (sectionCountry === currentCountry) {
        return section;
      }
    }

    return null;
  }

  async function getOnlineShops(url) {
    try {
      const doc = await fetchDocument(url);
      return findCountryList(doc);
    } catch (error) {
      console.error("Online shops fetch error:", error);
      return null;
    }
  }

  async function appendNewShopList() {
    shopsListContainer.classList.remove("empty");

    for (const url of pageUrls) {
      const match = await getOnlineShops(url);

      if (match) {
        shopsListContainer.innerHTML = match.innerHTML;
        return;
      }
    }

    shopsListContainer.classList.add("empty");
  }
})();